<template>
  <v-navigation-drawer
    v-model="show"
    disable-route-watcher
    fixed
    floating
    right
    temporary
    height="100vh"
    class="elevation-5"
  >
    <!-- The content -->
    <v-container fluid>
      <!-- The title of the sidebar -->
      <v-layout class="mb-4">
        <v-flex
          class="text-xs-center blue-grey--text headline font-weight-light"
        >
          Samples
          <v-btn icon absolute right @click="getSamples">
            <v-icon color="blue-grey">refresh</v-icon>
          </v-btn>
          <v-text-field
            v-model="termSampleFilter"
            clearable
            label="Buscar término..."
            prepend-icon="help"
          />
        </v-flex>
      </v-layout>
      <!-- A spinner to show while loading -->
      <v-layout v-if="loading.samples" class="my-5">
        <v-flex class="text-xs-center">
          <v-pulse-loader :loading="loading.samples" />
        </v-flex>
      </v-layout>
      <!-- The products -->
      <v-layout v-else wrap>
        <v-flex v-for="(item, index) in samples" :key="index" class="py-3">
          <label class="select-label" v-if="item.classificationId"
            >({{ item.classificationId }})
            {{ item.classificationBreadcrumb }}</label
          >
          <v-item-card
            :item="item"
            disable-toggle
            :ripple="false"
            :hover="false"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } =
  createNamespacedHelpers("classifier");

import VItemCard from "./ItemCard";
import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    VItemCard,
    VPulseLoader,
  },
  computed: {
    ...mapState(["loading", "samples", "showSamplesSidebar", "termSample"]),
    show: {
      get() {
        return this.showSamplesSidebar;
      },
      set(value) {
        this.setShowSamplesSidebar(value);
      },
    },
    termSampleFilter: {
      set(term) {
        this.setTermSample(term);
      },
      get() {
        return this.termSample;
      },
    },
  },
  watch: {
    show() {
      if (this.show && !this.samples.length) {
        this.getSamples();
      }
    },
  },
  methods: {
    ...mapActions(["getSamples"]),
    ...mapMutations(["setShowSamplesSidebar", "setTermSample"]),
  },
};
</script>